export const setsPath = {
  /* inject path */

  SETS_WORDS: '/sets/sets-words/:id/:name',
  SETS_WORDS_URI: '/sets/sets-words',
  EDIT_SET: '/sets/edit-set/:id',
  EDIT_SET_URI: '/sets/edit-set',

  TRASH_SET_URI: '/sets/edit-set',

  ADD_NEW_SET: '/sets/add-new-set',
  DASHBOARD: '/sets/dashboard',
  SETS_TABLE: '/sets/sets-table',
};
